// extracted by mini-css-extract-plugin
export default {"container":"container--cpaCJ","sign":"sign--iP5C9"};